import {
  beneficiaryKeys,
  trustAccountActivityKeys,
  trustAccountKeys
} from '@/features/trust-accounts/hooks';

import {buyerKeys} from '../hooks/useBuyersQuery';
import {paymentKeys} from '../hooks/usePaymentsQuery';
import {purchaseSummaryKeys} from '../hooks/usePurchaseSummaryQuery';

import type {QueryClient} from '@tanstack/react-query';

/**
 * Shared by every buyer roster mutation — create, add-to-purchase, and delete — since all three
 * change the same set of derived queries: the buyer list/detail, the beneficiaries (buyers hold a
 * beneficiary role), the purchase summary, the payments list, the activity tab counts, and the
 * trust account lists (each row shows its buyer count).
 */
export function invalidateBuyerCaches(
  queryClient: QueryClient,
  trustAccountId: string,
  buyerIds: string[]
): void {
  queryClient.invalidateQueries({queryKey: buyerKeys.lists(trustAccountId)});
  queryClient.invalidateQueries({queryKey: beneficiaryKeys.lists(trustAccountId)});
  // A reused buyer ID may have a cached detail entry predating this change — invalidate it too.
  for (const buyerId of buyerIds) {
    queryClient.invalidateQueries({queryKey: buyerKeys.detail(trustAccountId, buyerId)});
  }
  // Invalidate tab counts so badge updates immediately
  queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.tabCounts(trustAccountId)});
  queryClient.invalidateQueries({queryKey: purchaseSummaryKeys.detail(trustAccountId)});
  queryClient.invalidateQueries({queryKey: paymentKeys.lists(trustAccountId)});
  queryClient.invalidateQueries({queryKey: trustAccountKeys.lists()});
}
